export const hasField = (field) => (obj = {}) => obj[field] && obj[field] !== 'false'
export const isClearAll = hasField('clearAll')
export const isRecommended = hasField('recommended')
